import React, {Component} from 'react';
import {observer} from 'mobx-react';
import Button from '../common/Button'

const CustomerActions = observer(
    class CustomerActions extends Component {
        render() {
            return (
                <div className="page-body-action-buttons">
                    {this.props.actions.map((action, idx) => (
                        <Button key={idx} disabled={action.disabled} onClick={action.onClick}>{action.label}</Button>
                    ))}
                </div>
            )
        }
    }
)

export default CustomerActions;